import { JBadgeListProps } from "../JBadgeList"
import { CMSBanner, CMSSection } from "./CMSConfig"

/**
 * Ogni pagina, normale o dettaglio di un entità(evento, Content, etc.) può prevedere dei contenuti statici inseriti in fondo alla pagina dopo il contenuto standard gestito.
 */
export namespace CMSStaticSection {
    export enum Types {
        STATIC_CONTENT = 'STATIC_CONTENT',
        STATIC_SLIDER = 'STATIC_SLIDER',
        STATIC_CARD = 'STATIC_CARD',
        STATIC_MODAL = 'STATIC_MODAL',
        STATIC_BANNER = 'STATIC_BANNER',
        STATIC_HOW_TO = 'STATIC_HOW_TO',
        STATIC_FAQ = 'STATIC_FAQ'
    }
    export interface Content extends CMSSection {
        type: Types.STATIC_CONTENT,
        sections: (Slider | Banner | Content | HowTo | FaqTemplate)[]
    }
    export interface HowTo extends CMSSection {
        type: Types.STATIC_HOW_TO,
        sections: CMSSection[]
    }
    export interface FaqTemplate extends CMSSection {
        type: Types.STATIC_FAQ,
        sections: CMSSection[]
    }
    export interface Slider extends CMSSection {
        type: Types.STATIC_SLIDER
        options?: {
            slideToShow?: number,
            showAlwaysArrow?: boolean,
            disableInfiniteLoop?: boolean
        },
        sections: (Card | Banner)[]
    }
    export type ImagePosition = 'none' | 'contain' | 'cover' | 'fill' | 'scale-down'
    export type ImagePadding = 'none' | 'small' | 'medium'
    export interface Card extends CMSSection {
        type: Types.STATIC_CARD,
        options?: {
            clickable?: boolean,
            imagePosition?: ImagePosition
            imagePadding?: ImagePadding 
            contentImage?: string,
            walletBadge?: JBadgeListProps['items'], 
            headerContent?: {
                text: string,
                backgroundColor: string
                color: string
            }
        }
        sections?: Modal[]
    }
    export interface Modal extends CMSSection {
        type: Types.STATIC_MODAL,
        sections?: undefined
    }

    export interface Banner extends CMSBanner {
        type: Types.STATIC_BANNER
    }


    export function isStaticContent(section: CMSSection): section is Content {
        return section.type === Types.STATIC_CONTENT
    }
    export function isHowTo(section: CMSSection): section is HowTo {
        return section.type === Types.STATIC_HOW_TO
    }
    export function isFaqTemplate(section: CMSSection): section is FaqTemplate {
        return section.type === Types.STATIC_FAQ
    }
    export function isSlider(section: CMSSection): section is Slider {
        return section.type === Types.STATIC_SLIDER
    }
    export function isCard(section: CMSSection): section is Card {
        return section.type === Types.STATIC_CARD
    }
    export function isModal(section: CMSSection): section is Modal {
        return section.type === Types.STATIC_MODAL
    }
    export function isBanner(section: CMSSection): section is Banner {
        return section.type === Types.STATIC_BANNER
    }
}